module.exports = require("./zen-observable.js").Observable;



//////////////////
// WEBPACK FOOTER
// ./~/zen-observable/index.js
// module id = 1660
// module chunks = 1